export const trackEvent = (category, action, label) => {
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  });
};

const createTrackLinkEvent = (type) => (e) => {
  const url = e.currentTarget.getAttribute('href');
  trackEvent(type, 'link', url);
};

export const trackExternalLinkEvent = createTrackLinkEvent('external');

export const trackInternalLinkEvent = createTrackLinkEvent('internal');
